import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIcon
  ]
})
export class PillComponent {

  @Input() text?: string;
  @Input() fontSize!: string;
  @Input() fontColor?: string = 'white';
  @Input() backgroundColor?: string;
  @Input() closeable?: boolean = false;

  @Output() closeClickEvent = new EventEmitter<any>();

  onCloseClick() {
    this.closeClickEvent.emit();
  }
}